export default {
  global: {
    parentTitle: '家长端',
    enter: '登录',
    back: '返回',
    next: '下一步',
    backToSchedule: '回到课表页面',
    backToCourse: '回到课程页',
    error: '系统问题',
    trtAgain: '请重新尝试',
    noData: '暂无数据',
    hLogo: '一站式线上兴趣班',
    hLogoempty: '',
    hPhoneNum: '电话号码',
    hDownload: '名额有限，今日0元领！',
    select: '+1 美国',
    name: '学生昵称',
    phone: '电话号码',
    plase: '请输入您的手机号码',
    email: '电子邮件',
    wechat: '微信',
    submit: '立即领取',
  },
  index: {
    timeZone: '您所在时区：',
    profile: '个人中心',
    phone: '手机号',
    location: '地区',
    email: '邮箱',
    referrer: '推荐人',
    creditBalance: '剩余课时',
    topUp: '充值',
    viewDetails: '细节',
    myChild: '我的小孩',
    ofBirth: '生日',
    editChild: '编辑信息'
  },
  searchTabBar: {
    selectChild: '选择小孩',
    all: '全部',
    Showing: '显示:',
    scheduled: '已预约课程',
    course: '我的课程',
    completedLesson: '已完课'
  },
  tabBar: {
    noLesson: '当前没有排课',
    download: '',
    downloadAppStore: '去Appstore下载',
    downloadGooglePlay: '去Google Play下载'
  },
  login: {
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    enterPassword: '输入密码',
    confirmPassword: '确认密码',
    reset: '确认',
    savedPsw: '密码已更改',
    backSign: '回到注册/登录页',
    currentPasswordPlaceholder: '请输入当前密码',
    newPasswordPlaceholder: '请输入新密码',
    confirmPasswordPlaceholder: '确认新密码'
  },
  auth: {
    slogan: '让孩子轻松学会地道中文',
    subtitle: '3-18岁分级母语式中文课程，先听说后读写，绘本动画趣味课堂',
    codeLoginTab: '手机号验证码登录',
    passwordLoginTab: '手机号密码登录',
    loginTitle: '登录',
    phonePlaceholder: '输入手机号',
    codePlaceholder: '输入验证码',
    passwordPlaceholder: '输入密码',
    login: '登录',
    termsLogin: '登录即代表您已阅读并同意',
    saveNewPassword: '保存新密码'
  },
  signIn: {
    signIn: '登录',
    register: '注册',
    enterInfo: '输入您的手机号完成注册',
    sentCode: '您将会收到验证码',
    phone: '手机号',
    code: '发送验证码',
    verifiCode: '验证码',
    repeatVerifiCode: '重发验证码',
    second: '秒',
    enter: '登录',
    enterPsw: '用密码登录',
    password: '密码',
    forgetPassword: '忘记密码',
    signIncode: '获取短信验证码注册/登录',
    searchArea: '查询国家号'
  },
  header: {
    resetPassword: '重置密码',
    logout: '退出',
    setting: '设置'
  },
  main: {
    topic: '课节主题：',
    attendee: '同学：',
    viewFeedback: '查看反馈',
    leaveFeeback: '家长评教',
    teacherComments: '教师点评',
    rating: '评分',
    comment: '您的留言',
    commentHere: '在此处键入您的评论',
    send: '保存',
    sendSuccess: '课节反馈成功',
    enterClassRoom: '进入课堂',
    PresentationPreview: '课件预览',
    requestLeave: '取消课程',
    leave: '已请假',
    beginToEnter: '课节开始前 5 分钟能进入课堂',
    timeOut: '将于',
    timeOut_1: '开始',
    OnAir: '正在直播中',
    inProgress: '上课中',
    noStart: '未开始',
    completed: '已完成',
    cancel: '已取消',
    hours: ' 小时 ',
    hr: ' 小时 ',
    mins: '分钟',
    sickTitle: '取消课程',
    askTo: '您确定帮',
    currentCredit: '请假吗？',
    subject: '科目',
    date: '日期',
    time: '时间',
    confirmSick: '确认'
  },
  course: {
    nextLesson: '下节课时间',
    viewCurriculum: '查看课程大纲',
    title: '课程大纲',
    subjectDescription: '科目介绍',
    levels: '单元',
    best: '适合',
    yearold: '岁小孩',
    lessonTopic: '课节主题',
    totalLesson: '总共课节数：'
  },
  email: {
    accountInfo: '账号信息',
    emailAddress: '邮箱',
    referralCode: '推荐码（选填）',
    entercode: '输入推荐码',
    ParentFullName: '家长全名',
    WechatID: '微信ID',
    nowechatname: '（没有微信名称）',
    FriendReferralPrograms: '朋友推荐信息',
    EnterYourReferralCode: '输入你的推荐码',
    EnterCode: '输入代码',
    fail: '推荐码验证失败'
  },
  myChild: {
    addProfile: '添加信息',
    pickAvatar: '选择头像',
    childName: '小孩名字',
    childBirth: '小孩出生年月日',
    deleteChild: '删除小孩',
    editProfile: '编辑信息',
    saveChange: '确认变更',
    add: '添加',
    edit: '编辑',
    select: '确定',
    name: '姓名',
    editChildProfile: '编辑小孩信息',
    addChild: '添加小孩',
    editChild: '编辑小孩',
    whoAttend: '请选择上课的小孩',
    minimumChild: '请加入至少一个小孩',
    sureToLeave: '输入没有保存，确认要离开吗？',
    sureToDelete: '你确定要删除',
    sureToWho: '的信息吗？',
    yes: '是的',
    no: '不是',
    Next: '下一步',
  },
  payment: {
    paySuccess: '付款成功',
    payment: '支付明细',
    detail: '详情',
    price: '价格：',
    credits: '课时：',
    backMain: '返回首页',
    hpayment: '付款详情',
    hdetail: '套餐详情',
    hcredits: '课程:',
    hPayPlease: '*请关闭网站',
    hPayGoBack: '并返回Panda Mandarin应用程序',
    hPaySeeBalance: '查看您的剩余课时！'
  },
  payList: {
    creditTitle: '课时记录',
    paymentTitle: '付费记录',
    total: '总剩余课时',
    date: '筛选时间',
    range: '时间范围',
    dash: '/',
    reset: '重设筛选',
    dateTitle: '时间',
    description: '描述',
    credits: '课时变化',
    orderNo: '订单号',
    paid: '付款金额(¥)'
  },
  recharge: {
    topup: '购买课时',
    currentCredit: '剩余课时',
    manyCredit: '请问您想购买多少课时？',
    selectPackage: '请选择以下套餐',
    toPay: '前往购买页',
    empty: '',
    credits: '课时',
    extra: '额外',
    free: '免费',
    hCurrentCredit: '现有课时',
    hPay: '支付',
    hExtraCredits: '个额外免费课时',
    hFree: ''
  },
  errorprompt: {
    phoneEmpty: '请输入您的手机号',
    phoneError: '手机号格式不正确',
    selectAvatar: '请选择头像',
    selectBirthday: '请选择学生生日',
    selectName: '请输入学生名字',
    selectChild: '请选择学生',
    nameEmpty: '家长全名不能空置',
    wechatEmpty: '微信ID不能空置',
    emailEmpty: '邮箱不能空置',
    emailError: '邮箱格式不正确',
    referralError: '推荐码不正确',
    emailBeSend: '电邮已经发送',
    passwordEmpty: '密码不能空置',
    verificationEmpty: '验证码不能空置',
    verificationError: '验证码格式不正确',
    passwordLessThan: '密码至少得有七位数字或字母组成',
    passwordError: '密码格式不正确',
    currentpswEmpty: '旧密码不能空置',
    currentpswError: '旧密码格式不正确',
    newPswEmpty: '新密码不能空置',
    newPswSameAs: '新密码不能跟旧密码一样',
    newPswError: '新密码格式不正确',
    newPswDontSame: '两个新密码都不一致',
    del_1: '确定删除',
    del_2: '删除成功',
    del_3: '确定',
    del_4: '取消',
  },
  test2: {
    Next_class: '下节课时间',
    meet: '频率',
  },
  new_header: {
    Unlimited: '会员套餐',
    information: '用户中心',
    TransactionOrderHistory: '支付订单',
    MonthlyPassUser: '我的会员套餐',
    MonthyuStatement: '课时消费明细',
    Log_out: '退出登录',
    Expires: '到期',
    UserAgreement: '用户协议',
    totalCredit: '总课时',
    purchasedCredit: '充值课时',
    rewardCredit: '赠送课时',
    recharge: '充值',
  },
  new_index: {
    home: '首页',
    CurrentMonthLessons: '本月约课数量',
    Completed: '已完课',
    Scheduled: '已预约',
    NoShow: '缺勤',
    Remaining: '缺勤',
    HelloParent: '你好，{name}家长！',
    editInfo: '编辑信息',
    Attend_Class_Now: '直播课',
    Class_Enrolled: '系列课',
    View_Completed_Lessons: '已完课',
    Schedule_a_Class: '约课',
    Purchase_Lesson_Plan: '课时/会员充值',
    Dear_customer: '尊敬的客户 ',
    If: '如果想变更您的套餐。',
    Please: '请联系我们的客服。',
    Address: '地址信息',
    Videoclass: '录播课',
    Homework: '作业',
    changeCurrentChildren: '切换学生'
  },
  new_test1: {
    In_progress: '进行中',
    Level: '单元',
    Topic: '课程',
    Type: '类型',
  },
  new_test2: {
    Class_Enrolled: '固定课',
    In_progress: '进行中',
    Not_Started: '未开始',
    Completed: '已完成',
    Level: '单元',
    Topic: '课程',
    Student: '学生'
  },
  new_test3: {
    Level: '单元',
    Topic: '课程'
  },
  new_test4: {
    Schedule_a_Class: '报名课程',
    Sch_content: '您可以在Panda Mandarin 家长端 APP联系我们，了解更多信息。',
    Mandy: 'Mandy',
    your: '您的课程顾问',
    Wechat_ID: '微信号'
  },
  new_test5: {
    Pick_a_Plan: '选择一个套餐',
    Number_of_Kids: '适合的学生人数',
    Pay_as_You_Go: '购买课时',
    Continue: '下一步',
    sessions: '节课'
  },
  information: {
    Profile: '个人中心',
    Parent_Full_Time: '家长姓名',
    Phone_no: '手机号',
    Location: '地区',
    Email: '邮箱',
    Password: '密码',
    Change: '修改',
    Preferred_language: '语言',
    editProfile: '编辑语言',
    English: 'English',
    Simplified_Chinese: '中文（简体）'

  },
  Transaction: {
    History: '支付订单',
    Order: '订单号',
    Date: '日期',
    Description: '课时',
    Paid: '付款金额',
    Status: '状态',
    Contract: '合同',
    PaidCreditLabel: '付费课时',
    FreeCreditLabel: '免费课时',
    ViewContract: '查看合同',
  },
  MonthlyPassUser: {
    Monthly_Pass_User: '我的会员套餐',
    Pass_Information: '我的会员套餐',
    kid: '个小孩',
    Month: '月',
    Pass_Expires: '会员到期时间',
    Next_billing_date: '下次扣款日期',
    view_charges: '费用记录',
    view_billing_history: '支付记录',
    Payment_method: '付款方式',
    Mastercard_ending_in: '银行卡',
    Update: '修改',
    Expires: '到期时间',
    Changing: '更改计划？请联系您的课程顾问寻求帮助',
    Wechat_ID: '微信号'
  },
  addChildren: {
    Edits: '切换学生',
    Childs_Name: '学生名称',
    Child_Birthday: '学生生日',
    add: '添加学生',
    addNew: '新增学生',
    breadcrumbHome: '首页',
    breadcrumbEdit: '编辑信息',
    Delete: '删除',
    Edit: '编辑'
  },
  Change_Plan: {
    ChangePlan: '修改套餐',
    Current_Plan: '当前套餐',
    year: '年',
    month: '月',
    New_Plan: '新套餐',
    Payment_method: '支付方式',
    Mastercard: '银行卡',
    Update: '修改',
    Expires: '到期',
    Change_Plan: '修改套餐',
    Months: '月',
    kids: '个学生',
    What: '下一步',
    Change_Plan: '修改套餐'
  },
  homework: {
    selectMonth: '选择月',
    homeworkTime: '作业时间：{start} 至 {end}',
    preview: '预览',
    download: '下载',
    viewHomework: '查看作业',
    viewWord: '查看作业',
    viewVideo: '查看视频',
    listenAudio: '听录音',
    myAnswer: '我的作答',
    enterContent: '请输入内容',
    addImage: '添加图片',
    addDocument: '添加文档',
    addVideo: '添加视频',
    addAudio: '添加音频',
    fileSizeLimit: '（文件大小10M以内）',
    fileSizeLimitMedia: '（文件大小500M以内）',
    clickUpload: '点击上传',
    transcoding: '数据转码中...',
    saveDraft: '保存为草稿',
    submitHomework: '提交作业',
    recallAndEdit: '撤回并编辑',
    myHomework: '我的作业',
    teacherReview: '{name}老师批阅',
    emptyMonth: '您当月没有作业，查一下其他月份吧。',
    uploading: '正在上传中...{progress}%',
    fileTypeError: '{name}文件类型出错,只可上传{accept}后缀的文件!',
    fileSizeError: '{name}文件大小超过限制，最大允许10MB!',
    fileSizeErrorMedia: '{name}文件大小超过限制，最大允许500MB!',
    mediaPreviewError: '播放器加载失败，已在新窗口打开',
    emptySubmitError: '没有作答内容，无法保存或提交作业！',
    status: {
      notSubmitted: '未提交',
      submitted: '已提交',
      reviewed: '已批阅',
      draft: '草稿',
      ended: '已结束',
    },
    score: {
      fail: '不及格',
      fair: '一般',
      medium: '中等',
      good: '良好',
      excellent: '优秀',
    }
  },
  videoClass: {
    title: '录播课',
    breadcrumb: '录播课 / 课程详情',
    selectMonth: '选择月',
    emptyMonth: '您当月暂时没有录播课，查一下其他月份吧。',
    statusLabel: '状态',
    classTime: '上课时间',
    anytime: '随到随学',
    learned: '已学',
    intro: '简介',
    introColon: '简介：',
    lastViewed: '上次浏览',
    continueLearning: '继续学习 GO!',
    startLearning: '开始学习 GO!',
    courseCatalog: '课程目录',
    courseInfo: '课程详情',
    chapterLessons: '（ {count}小节 ）',
    video: '视频',
    courseCover: '课程封面',
    chapterCover: '章节封面',
    studying: '学习中',
    lastStudy: '上次学习',
    status: {
      notStarted: '未学习',
      inProgress: '进行中',
      completed: '已学完',
    }
  },
  Monthly: {
    Monthlys: '课时消费明细',
    Date: '日期',
    studen: '学生',
    class: '课程',
    Class_size: '课程类型',
    Credit: '课时',
    Requried: '实际消费课时',
    Status: '状态',
    yue: '选择月',
    CreditType: '消费课时类型',
    FreeCredit: '免费课时',
    PaidCredit: '付费课时',
    Detail: '详情',
  },
  Payment: {
    Complete: '完成支付',
    Go_Back: '返回',
    Personal_Infomation: '个人信息',
    Payment_Method: '支付方式',
    Pay_Now: '立即支付',
    describe: '如果继续，我同意 <span style="color:#4B69FE;text-decoration:underline;">付款授权服务协议</span> 包括 <span style="color:#4B69FE;text-decoration:underline;">退款政策</span>。我已经阅读 <span style="color:#4B69FE;text-decoration:underline;">儿童网络隐私保护规定家长通知</span>。我同意订阅 Class over 简讯，短信，并接受 <span style="color:#4B69FE;text-decoration:underline;">使用条款</span> 和 <span style="color:#4B69FE;text-decoration:underline;">隐私政策</span>。',
  },
  pay_Success: {
    Go_Home: '返回首页',
    Payment: '支付成功!',
    We: '我们将很快与您联系',
    You: '您将很快收到一封确认电子邮件',
    Below: '以下是你的课程顾问联系方式',
    Total: '总计',
    month: '月',
    Best: 'Best Value'
  },
  "Congratulation!": "恭喜 ！",
  "You have a Special Offer!": "您的专属折扣 ！",
  "You have": "仅剩",
  "Hours": "时",
  "Minutes": "分",
  "Seconds": "秒",
  "Nomore": "没有更多了",
  "reached": "您已经拉倒最底部啦！",
  sharefree: {
    educators: "美国中小学在职精英教师团队",
    sessions: "独创“TALENT”教学法，教学效果显著",
    parents: "无限上课：1-6人小班直播课",
    Match: "20+科目自由组合",
  },
  Childdialog: {
    Parent: "亲爱的家长：",
    advisor: "如果想添加小孩，请联系我们的课程顾问老师！",
    title: "请联系您的专属顾问添加学生",
  },
  "Country Code": "国家区号",
  "Please select your country code": "请选择国家区号",

  "Sign in": "登入",
  "Please use Google Chrome or Microsoft Edge to improve your experience.": "请使用 Google Chrome 或 Microsoft Edge 来提升您的体验",
  "Verification Code": "验证码登入",
  "Passwordon": "密码登入",
  "Password": "密码",
  "Phone number": "手机号",
  "Verification code": "验证码",
  "Send": "发送",
  "Continue": "继续",
  "By continuing, you agree to our ": "点击继续，即表示您同意我们的",
  "ServiceAgreement": '用户服务协议',
  "and": '和',
  "PrivacyPolicy": '隐私政策',
  "Welcome to Panda Mandarin": "欢迎来到 Panda Mandarin",
  "Please tell us a little about yourself": "请告诉我们一些关于您的信息",
  "Phone Number": "电话号码",
  "Kid(s) Nickname": "学生昵称",
  "Email address": "电子邮箱",
  "Wechat ID": "微信号",
  "Submit": "提交",
  "Thank you for choosing us": "感谢您选择我们",
  "Your Course Adviser will contact you shortly": "您的课程顾问稍后会联系您",
  "Back": "返回",
  "Please use": "请使用 Google Chrome 或 Microsoft Edge 来提升您的体验",
  "Please select your country code": "请选择国家区号",
  "Please verify and enter the text in the picture": "请进行验证,输入图片内的文字",
  "The Verification Code can not be empty": "验证码不能为空",
  "Please enter the contents": "请输入内容",
  "Success": "确定",
  "Click Refresh Verification Code": "点击刷新验证码",
  "User Does Not Exist": "用户不存在，请重新输入",
  "Wrong password": "密码错误, 请重新输入",
  "Dont have an account": "新用户未注册？",
  "Sign up to get a free lesson": "注册立即领取免费试课",
  "Congratulations!": "恭喜您！",
  "You have claimed a free trial lesson": "成功获得了一节超值试听课机会",
  "Our Course Adviser will contact you shortly": "我们的课程顾问老师稍后会和您联系",
  saleCard: {
    title: '恭喜领取熊猫中文试听课！',
    desc: '熊猫中文是针对3-18岁年龄段的分级式中文课程，系统性强、趣味性高、学习效果好，适合华裔孩子和零基础孩子学习。',
    cta: '扫码添加课程顾问微信'
  },
  "Paid Credit": "购买课时",
  "Refundable": "可退款",
  "Reward Credit": "奖励课时",
  "Non-Refundable": "不可退款",
  "For more information please read": "了解更多信息请阅读",

}



// WEBPACK FOOTER //
// ./src/i18n/zh-CN.js